"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle, X } from "lucide-react";
import type { CsvImportResult } from "./types";

interface ImportResultsProps {
  importResults: CsvImportResult[];
}

/**
 * Results display component after CSV import completes
 */
export function ImportResults({ importResults }: ImportResultsProps) {
  const successfulImports = importResults.filter((r) => r.success).length;
  const failedImports = importResults.filter((r) => !r.success).length;

  if (importResults.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Import Results</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 text-green-600">
              <CheckCircle className="h-4 w-4" />
              <span>{successfulImports} successful</span>
            </div>
            {failedImports > 0 && (
              <div className="flex items-center gap-2 text-red-600">
                <X className="h-4 w-4" />
                <span>{failedImports} failed</span>
              </div>
            )}
          </div>

          {failedImports > 0 && (
            <div className="space-y-2 max-h-40 overflow-y-auto">
              {importResults
                .filter((r) => !r.success)
                .map((result, index) => (
                  <div key={index} className="p-2 bg-red-50 border border-red-200 rounded text-sm dark:bg-red-950/40 dark:border-red-800">
                    <span className="font-medium">Row {result.row}:</span> {result.error}
                  </div>
                ))}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
